import {useCallback, useRef, useState} from 'react'

// Shared by useAccountTree (Account Setup) and useAddressValidation
// (AccountsTabs edit modal) to pause a save/validate flow and let the user
// pick between what they typed and Google's recommended correction, instead
// of hard-blocking on an UNCONFIRMED_BUT_PLAUSIBLE address match.
export function useAddressSuggestionPrompt() {
  const [addressSuggestion, setAddressSuggestion] = useState(null)
  const resolverRef = useRef(null)

  const promptForConfirmation = useCallback(
    ({original, recommended, message}) => {
      return new Promise(resolve => {
        resolverRef.current = resolve
        setAddressSuggestion({original, recommended, message})
      })
    },
    [],
  )

  const resolveAddressSuggestion = useCallback(choice => {
    resolverRef.current?.(choice)
    resolverRef.current = null
    setAddressSuggestion(null)
  }, [])

  return {addressSuggestion, promptForConfirmation, resolveAddressSuggestion}
}
